import { render, staticRenderFns } from "./BaseInputCustom.vue?vue&type=template&id=107d87a3"
import script from "./BaseInputCustom.vue?vue&type=script&lang=js"
export * from "./BaseInputCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports